import styles from './layout-stub.module.css';
import { Spinner } from '../../ui/spinner/spinner';

export const LayoutStub = () => {
  return (
    <div className={styles.layout}>
      <Spinner />
    </div>
  );
};
